<template>
  <f7-button
    :raised="!isReading"
    large
    fill
    class="article-btn-play"
    :color="color"
    @click="play">
    <FlatIcon
      :size="32"
      :name="icon" />
    {{ text }}
  </f7-button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ArticleBtnPlay',
  props: {
    marker: {
      type: Object,
      required: true
    },
    playlist: {
      type: Array
    },
    autoplay: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters({
      markerSpeech: 'speech/markerSpeech',
      currentIndex: 'speech/currentIndex',
      paused: 'speech/paused'
    }),
    isCurrent () {
      if (this.markerSpeech) {
        return this.marker._id === this.markerSpeech._id
      } else {
        return false
      }
    },
    isReading () {
      return this.isCurrent && !this.paused && this.currentIndex > -1
    },
    icon () {
      if (this.isReading) return 'stop-white'
      return 'play'
    },
    text () {
      if (this.isReading) return this.t('artStop')
      return this.t('artPlay')
    },
    color () {
      if (this.isReading) return 'blue'
      return 'white'
    }
  },
  methods: {
    ...mapActions({
      startMarkerPlaylist: 'speech/startMarkerPlaylist',
      stopCurrentPlaylist: 'speech/stopCurrentPlaylist',
      playTrackByIndex: 'speech/playTrackByIndex',
      resume: 'speech/resume',
      stop: 'speech/stop'
    }),
    play () {
      if (!this.isCurrent) {
        this.stop()
        this.startMarkerPlaylist({
          marker: this.marker,
          playlist: this.playlist
        })
      } else {
        if (this.isReading) this.stopCurrentPlaylist() // this.pause()
        else if (this.paused) this.resume()
        else this.playTrackByIndex(0)
      }
    }
  },
  created () {
    if (this.autoplay) this.play()
  }
}
</script>

<style lang="scss">
.article-btn-play {
  position: relative;
  padding-left: 30px !important;
  &.color-blue {
    background: var(--f7-color-blue);
  }
  &.color-white {
    color: var(--f7-color-blue);
  }
  .flat-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translate(0,-50%);
  }
}
</style>
